import { cn, SimpleTooltip } from 'design-system'
import { FC, HTMLAttributes, ReactNode, Ref } from 'react'

import { Link } from 'src/lib/router'

import {
  MAIN_NAV_ALERT_CLASS_NAME,
  MAIN_NAV_ITEM_CLASS_NAME,
  MAIN_NAV_ITEM_HOVER_CLASS_NAME
} from '../constants'

interface MainNavLinkProps extends HTMLAttributes<HTMLElement> {
  label: string
  icon: ReactNode
  onClick?: () => void
  alertCount?: number
  open?: boolean
  route?: string
  className?: string
  exact?: boolean
  ref?: Ref<HTMLButtonElement | HTMLAnchorElement>
}

export const MainNavLink: FC<MainNavLinkProps> = ({
  label,
  icon,
  onClick,
  alertCount = 0,
  open,
  route,
  className,
  exact,
  ref,
  ...rest
}) => {
  const truncatedAlertCount = alertCount > 99 ? '99+' : alertCount
  const finalLabel = alertCount > 0 ? `${label}, ${alertCount} new` : label

  const navLinkClassName = cn(
    MAIN_NAV_ITEM_CLASS_NAME,
    MAIN_NAV_ITEM_HOVER_CLASS_NAME,
    className
  )

  const alertClassName = cn(MAIN_NAV_ALERT_CLASS_NAME, {
    'text-xxs': alertCount > 99
  })

  return (
    <SimpleTooltip content={label} placement="right" strategy="fixed" noRest>
      {onClick ? (
        <button
          {...rest}
          ref={ref as Ref<HTMLButtonElement>}
          aria-label={finalLabel}
          {...(open !== undefined && {
            'aria-expanded': open ? 'true' : 'false'
          })}
          className={navLinkClassName}
          onClick={onClick}>
          {alertCount > 0 ? (
            <span aria-hidden="true" className={alertClassName}>
              {truncatedAlertCount}
            </span>
          ) : null}
          {icon}
        </button>
      ) : (
        <Link
          {...rest}
          href={route as string}
          ref={ref as Ref<HTMLAnchorElement>}
          aria-label={finalLabel}
          className={navLinkClassName}
          exact={exact}>
          {alertCount > 0 ? (
            <span aria-hidden="true" className={alertClassName}>
              {truncatedAlertCount}
            </span>
          ) : null}
          {icon}
        </Link>
      )}
    </SimpleTooltip>
  )
}
